
import LoginReducer from "../Reducers/LoginReducer";
import { combineReducers } from "redux";
import { ModalPopupReducer } from "../Reducers/ModalPopUpReducer";
import CommonMastersReducer from "../Reducers/CommonMastersReducer";


const Reducers = combineReducers({
  loginreducer: LoginReducer,
  modalState: ModalPopupReducer,
  commonMastersReducer: CommonMastersReducer,
});
export default Reducers;
